import { sanitizeHtml } from '../../utils/safeHtml';
import { ticketCommentToHtml } from '../../utils/plainTextToHtml';
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import {
    loadTicketCommentHtmlWithAuthImages,
    normalizeInlineImageParagraphs,
    rewriteTicketCommentHtmlImages,
} from '../../utils/ticketCommentImages';

const TicketCommentHtml = ({ htmlContent, onImageClick }) => {
    // Sanitiza a ENTRADA, antes de qualquer reescrita de imagem. A ordem
    // importa: o download autenticado troca o src por uma blob: URL, e
    // `blob:` nao sobrevive ao DOMPurify. Sanitizar depois faria sumir toda
    // imagem embutida de toda acao.
    //
    // Antes da sanitizacao vem a conversao de texto puro em HTML: as acoes
    // importadas do Movidesk chegam como texto com quebras de linha cruas, e o
    // innerHTML colapsa quebra de linha em espaco -- sem isto o historico dos
    // 262 mil chamados aparece como um paragrafo corrido.
    const [html, setHtml] = useState(() => {
        if (!htmlContent) return '';
        return rewriteTicketCommentHtmlImages(
            normalizeInlineImageParagraphs(sanitizeHtml(ticketCommentToHtml(htmlContent)))
        );
    });

    useEffect(() => {
        if (!htmlContent) {
            setHtml('');
            return undefined;
        }

        let cancelled = false;
        const normalized = normalizeInlineImageParagraphs(sanitizeHtml(ticketCommentToHtml(htmlContent)));
        const initial = rewriteTicketCommentHtmlImages(normalized);
        setHtml(initial);

        loadTicketCommentHtmlWithAuthImages(normalized).then((loadedHtml) => {
            if (!cancelled) {
                setHtml(loadedHtml);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [htmlContent]);

    if (!html) return null;

    return (
        <Box
            component="div"
            className="ticket-comment-html"
            // O HTML vem de dangerouslySetInnerHTML, entao nao da para pendurar
            // onClick na imagem: usa delegacao no container.
            onClick={(e) => {
                if (!onImageClick) return;
                const el = e.target;
                if (el && el.tagName === 'IMG' && el.src) {
                    onImageClick(el.src);
                }
            }}
            sx={{
                '& p': { margin: 0 },
                '& strong, & b': { fontWeight: '700 !important' },
                '& em, & i': { fontStyle: 'italic !important' },
                '& u': { textDecoration: 'underline' },
                '& s, & strike': { textDecoration: 'line-through' },
                // A imagem fica em bloco, no ponto do texto em que foi inserida: o
                // texto seguinte vai para baixo dela, nao ao lado. Com inline-block o
                // texto corria na lateral e a leitura da acao ficava confusa.
                '& img': {
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: 1,
                    display: 'block',
                    margin: '6px 0',
                    cursor: onImageClick ? 'zoom-in' : 'default',
                },
            }}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default React.memo(TicketCommentHtml);
